module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.b06871f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 434
// module chunks = 0